export default __webpack_public_path__ + "static/media/banner2.362b6204.webp";